import importerStore from '@shared/importer/importer-store';
import { AcademyService } from '@modules/academy/academy-service';
import academyImporterFields from '@modules/academy/academy-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  AcademyService.import,
  academyImporterFields,
  i18n('entities.academy.importer.fileName'),
  i18n('entities.academy.importer.hint'),
);
